// extracted by mini-css-extract-plugin
export default {"cards":"Card_cards__vjSL4","heading":"Card_heading__zoPSK","imgWrapper":"Card_imgWrapper__Va45e","img":"Card_img__Bxsu6","cardDesc":"Card_cardDesc__6uS+r"};